export class CacheConfigurableListItem
{
    public ID: number;
    public Description: string;
    public ListId: number;
    public Value: string;
    public Type: string;
    public FolderID: number;

    constructor(
        obj: CacheConfigurableListItem
    )
    {
        this.ID =  obj.ID;
        this.Description = obj.Description,
        this.ListId = obj.ListId,
        this.Value = obj.Value;
        this.Type = obj.Type;
        this.FolderID = obj.FolderID;
    }
}